import { logStatsigEvent } from './statsigConfiguration';

const enum StatsigPerformanceEventType {
  PerformanceItineraryRequested = 'performance_itinerary_requested',
  PerformanceItineraryReceived = 'performance_itinerary_received',
  PerformanceItineraryRendered = 'performance_itinerary_rendered',
  PerformanceItineraryTotalTimeToRender = 'performance_itinerary_total_time_to_render',
  PerformanceHotelListRequested = 'performance_hotel_list_requested',
  PerformanceHotelListReceived = 'performance_hotel_list_received',
  PerformanceHotelListRendered = 'performance_hotel_list_rendered',
  PerformanceHotelListTotalTimeToRender = 'performance_hotel_list_total_time_to_render',
  PerformanceActivityListRequested = 'performance_activity_list_requested',
  PerformanceActivityListReceived = 'performance_activity_list_received',
  PerformanceActivityListRendered = 'performance_activity_list_rendered',
  PerformanceActivityListTotalTimeToRender = 'performance_activity_list_total_time_to_render',
}

export function trackPerformanceItineraryRequested(timeToEvent: number): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceItineraryRequested,
    timeToEvent
  );
}

export function trackPerformanceItineraryReceived(timeToEvent: number): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceItineraryReceived,
    timeToEvent
  );
}

export function trackPerformanceItineraryRendered(timeToEvent: number): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceItineraryRendered,
    timeToEvent
  );
}

export function trackPerformanceItineraryTotalTimeToRender(
  timeToEvent: number
): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceItineraryTotalTimeToRender,
    timeToEvent
  );
}

export function trackPerformanceHotelListRequested(timeToEvent: number): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceHotelListRequested,
    timeToEvent
  );
}

export function trackPerformanceHotelListReceived(timeToEvent: number): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceHotelListReceived,
    timeToEvent
  );
}

export function trackPerformanceHotelListRendered(timeToEvent: number): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceHotelListRendered,
    timeToEvent
  );
}

export function trackPerformanceHotelListTotalTimeToRender(
  timeToEvent: number
): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceHotelListTotalTimeToRender,
    timeToEvent
  );
}

export function trackPerformanceActivityListRequested(
  timeToEvent: number
): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceActivityListRequested,
    timeToEvent
  );
}

export function trackPerformanceActivityListReceived(
  timeToEvent: number
): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceActivityListReceived,
    timeToEvent
  );
}

export function trackPerformanceActivityListRendered(
  timeToEvent: number
): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceActivityListRendered,
    timeToEvent
  );
}

export function trackPerformanceActivityListTotalTimeToRender(
  timeToEvent: number
): void {
  logStatsigEvent(
    StatsigPerformanceEventType.PerformanceActivityListTotalTimeToRender,
    timeToEvent
  );
}

const enum DeserializeFlowEventType {
  DeserializeHotelWithOldIngredientPrefix = 'deserialize_hotel_with_old_ingredient_prefix',
  DeserializeHotelWithoutHotelFiltersPrefix = 'deserialize_hotel_without_hotel_filters_prefix',
  DeserializeHotelWithoutSuggestionOrderPrefix = 'deserialize_hotel_without_suggestion_order_prefix',
  DeserializeHotelWithOldRoomPrefix = 'deserialize_hotel_with_old_room_prefix',
  DeserializeHotelWithoutBoardBasisPrefix = 'deserialize_hotel_without_board_basis_prefix',
  DeserializeHotelWithoutRoomTypeId = 'deserialize_hotel_without_room_type_id',
  DeserializeTransportWithCoordinates = 'deserialize_transport_with_coordinates',
  DeserializeTransportWithoutSuggestionOrderPrefix = 'deserialize_transport_without_suggestion_order_prefix',
}

interface DeserializeFlowMetadata extends Record<string, string> {
  url: string;
  referrer: string;
}

function getDeserializeFlowMetadata(): DeserializeFlowMetadata {
  return {
    url: window.location.href,
    referrer: document.referrer,
  };
}

export function trackDeserializeHotelWithOldIngredientPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldIngredientPrefix,
    undefined,
    getDeserializeFlowMetadata()
  );
}

export function trackDeserializeHotelWithoutHotelFiltersPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutHotelFiltersPrefix,
    undefined,
    getDeserializeFlowMetadata()
  );
}

export function trackDeserializeHotelWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutSuggestionOrderPrefix,
    undefined,
    getDeserializeFlowMetadata()
  );
}

export function trackDeserializeHotelWithOldRoomPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldRoomPrefix,
    undefined,
    getDeserializeFlowMetadata()
  );
}

export function trackDeserializeHotelWithoutBoardBasisPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutBoardBasisPrefix,
    undefined,
    getDeserializeFlowMetadata()
  );
}

export function trackDeserializeHotelWithoutRoomTypeId(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutRoomTypeId,
    undefined,
    getDeserializeFlowMetadata()
  );
}

export function trackDeserializeTransportWithCoordinates(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeTransportWithCoordinates,
    undefined,
    getDeserializeFlowMetadata()
  );
}

export function trackDeserializeTransportWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeTransportWithoutSuggestionOrderPrefix,
    undefined,
    getDeserializeFlowMetadata()
  );
}
